// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__aXMuh","rootSmall":"AddTileButton_rootSmall__1n_-x"};